/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Pdf_Export_Failed_ShortInputs */

const en_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF export failed. Is the printer service running?`)
};

const de_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Export fehlgeschlagen. Läuft der Druckdienst?`)
};

const fr_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'export PDF. Le service d'impression est-il actif ?`)
};

const es_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en la exportación PDF. ¿Está activo el servicio de impresión?`)
};

const it_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione PDF non riuscita. Il servizio di stampa è in esecuzione?`)
};

const nl_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-export mislukt. Is de printerservice actief?`)
};

const pl_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksport PDF nie powiódł się. Czy usługa drukowania jest uruchomiona?`)
};

const fi_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-vienti epäonnistui. Onko tulostuspalvelu käynnissä?`)
};

const da_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-eksport mislykkedes. Kører printerservicen?`)
};

const sv_resumes_pdf_export_failed_short = /** @type {(inputs: Resumes_Pdf_Export_Failed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-export misslyckades. Körs utskriftstjänsten?`)
};

/**
* | output |
* | --- |
* | "PDF export failed. Is the printer service running?" |
*
* @param {Resumes_Pdf_Export_Failed_ShortInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_pdf_export_failed_short = /** @type {((inputs?: Resumes_Pdf_Export_Failed_ShortInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Pdf_Export_Failed_ShortInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_pdf_export_failed_short(inputs)
	if (locale === "fr") return fr_resumes_pdf_export_failed_short(inputs)
	if (locale === "es") return es_resumes_pdf_export_failed_short(inputs)
	if (locale === "it") return it_resumes_pdf_export_failed_short(inputs)
	if (locale === "nl") return nl_resumes_pdf_export_failed_short(inputs)
	if (locale === "pl") return pl_resumes_pdf_export_failed_short(inputs)
	if (locale === "fi") return fi_resumes_pdf_export_failed_short(inputs)
	if (locale === "da") return da_resumes_pdf_export_failed_short(inputs)
	if (locale === "sv") return sv_resumes_pdf_export_failed_short(inputs)
	return en_resumes_pdf_export_failed_short(inputs)
});